<script lang="ts" setup>
import { FormKitLazyProvider } from '@formkit/vue'
import type { DynamicAuctionItemList } from '@autobid/strapi-integration/rest/components'
import { useManufacturersToDisplay } from '@autobid/ui/composables/auction/useManufacturersToDisplay'
import { injectFilterComposable } from '@autobid/ui/utils/carsList/injectFilterComposable'
import { FormKit } from '@formkit/vue'
import { inject, ref } from 'vue'

const auctionStrapiData = inject<DynamicAuctionItemList>('auction-strapi-data')

const { manufacturesToDisplay } = useManufacturersToDisplay(
  auctionStrapiData?.type === 'carList' ? 'auction' : 'searchList',
)

const useFilter = injectFilterComposable()
const {
  filters: { manufacturerModel },
} = useFilter()

const brand = ref()
const model = ref('')
const error = ref('')
const { t } = useI18n()

function handleAddFilter() {
  if (!model.value && !brand.value) {
    error.value = t('cars-list.filters.manufacturer-not-filled-fields')
    return
  }

  let value = ''

  if (model.value && brand.value) {
    value = `${brand.value};${model.value}`
  }
  else if (model.value) {
    value = `;${model.value}`
  }
  else {
    value = `${brand.value};`
  }

  const currentValue = manufacturerModel.value || []

  if (!currentValue.includes(value)) {
    manufacturerModel.value = [...currentValue, value]
  }

  brand.value = undefined
  model.value = ''
}
</script>

<template>
  <div>
    
<FormKitLazyProvider config-file="true">
<form class="-mt-6" @submit.prevent="handleAddFilter">
      <FormKit
        v-model="brand"
        type="Select"
        :options="manufacturesToDisplay"
        :value="brand"
        :placeholder="$t('cars-list.filters.manufacturer')"
        @input="error = ''"
      />

      <FormKit
        v-model="model"
        type="text"
        :placeholder="$t('cars-list.filters.model')"
        :classes="{
          input:
            'w-full border-none py-2.5 pl-3 pr-10 font-light text-primary placeholder:text-primary placeholder:opacity-50 focus:ring-0',
        }"
        @input="error = ''"
      />

      <span v-if="error" class="relative top-1 -mb-4 block text-xs text-red">
        {{ error }}
      </span>

      <button
        type="submit"
        class="text-bold mt-5 flex items-center text-primary"
      >
        <Icon
          mode="css"
          size="28"
          name="zondicons:add-solid"
          class="mr-2 transition hover:scale-110"
        />

        {{ $t('cars-list.filters.add-manufacturer') }}
      </button>
    </form>
</FormKitLazyProvider>

  </div>
</template>
